const Medal1 = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" fill="none" />
    <path
      d="M10 0.833008C13.6819 0.833008 16.667 3.81812 16.667 7.5C16.667 9.60515 15.6909 11.4823 14.167 12.7041V17.9736C14.1669 18.8897 13.2137 19.4944 12.3848 19.1045L10 17.9824L7.61523 19.1045C6.78629 19.4943 5.83309 18.8897 5.83301 17.9736V12.7041C4.30915 11.4823 3.33301 9.60512 3.33301 7.5C3.33303 3.81813 6.31813 0.83303 10 0.833008ZM12.917 13.4961C12.036 13.9254 11.046 14.167 10 14.167C8.95405 14.167 7.96399 13.9254 7.08301 13.4961V17.9736L9.46777 16.8516C9.80487 16.6929 10.1951 16.6929 10.5322 16.8516L12.917 17.9736V13.4961ZM9.99023 4L8.2002 5.09375V6.76953L9.79102 5.81836H9.83398V11.2725H11.8086V4H9.99023Z"
      fill="#F6B60E"
    />
  </svg>
)

export default Medal1
